import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../../components/Blockquote';

const EquityTab = () => {
  return (
    <div className="pt-11">
      <Row>
        <h5>Equity</h5>
      </Row>
      <Row>
        <span className="text-light-grey text-fs-6 fw-light lh-xs">
          Don't miss out on these valuable benefits. Talk to your investment
          advisor about your choices today.
        </span>
      </Row>
      <Row className="pt-11 lh-xs px-4">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Let's help you understand this information
              </Col>
            </Row>
            <Row>
              <Col>
                Cash Compensation is shown by calendar year. Your current year
                amount represents what you have received year-to-date plus a
                projection based on your current pay rate.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-12 px-7">
        <Col className="lh-xs  ">
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom ">
            <Col className="d-flex pt-1 ps-0 col-9 align-items-center">
              <div
                className="custom-legend-marker"
                style={{
                  backgroundColor: '#C4D2D9',
                }}
              ></div>
              <div className='ms-3'> Dividend Distribution from Stock Options</div>
            </Col>
            <Col className="col-3 text-end pe-1">$6,500</Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom ">
            <Col className="d-flex pt-1 px-0 col-9 align-items-center">
              <div
                className="custom-legend-marker"
                style={{
                  backgroundColor: '#2A556D',
                }}
              ></div>
              <div className='ms-3'> Stock Settled Appreciation Rights</div>
            </Col>
            <Col className="col-3 text-end pe-1">$90,660</Col>
          </Row>
          <Row className="text-fs-6 fw-normal pt-3 pb-3 lh-xs border-bottom">
            <Col className='ps-0'>TOTAL</Col>
            <Col className="col-3 text-end pe-1"></Col>
            <Col className="col-3 text-end pe-1">$97,160</Col>
          </Row>
        </Col>
      </Row>
      <Row className="pt-12">
        <h5>Dividend Distribution</h5>
      </Row>
      <Row className="pt-11 px-7">
        <Col className="lh-xs  ">
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom ">
            <Col className="col-9 ps-0 ">
              Dividend Distribution from Stock Options
            </Col>
            <Col className="col-3 text-end pe-1">$6,500</Col>
          </Row>
        </Col>
      </Row>
      <Row className="pt-12">
        <h5>Restricted Stock Units (RSUs)</h5>
      </Row>
      <Row className="pt-11 px-7">
        <Col className="lh-xs  ">
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom text-end">
            <Col className="col-2">Grant Date</Col>
            <Col >Units Granted</Col>
            <Col className="col-5">Unvested Units</Col>
            <Col>Unvested Value</Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom text-end">
            <Col className="col-2">10/1/2021</Col>
            <Col >748</Col>
            <Col className="col-5">748</Col>
            <Col>$155,584</Col>
          </Row>
          <Row className="text-fs-6 fw-normal lh-xs pt-3 pb-3 border-bottom text-end">
            <Col className="col-2">Total</Col>
            <Col >748</Col>
            <Col className="col-5">748</Col>
            <Col>$155,584</Col>
          </Row>
        </Col>
      </Row>
      <Row className="pt-12">
        <h5>Stock Settled Appreciation Rights (SSARs)</h5>
      </Row>
      <Row className="pt-11 px-7">
        <Col className="lh-xs  ">
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom text-end">
            <Col>Grant Date</Col>
            <Col>Rights Granted</Col>
            <Col>Grant Price</Col>
            <Col>Rights Exercisable</Col>
            <Col>Unvested Rights</Col>
            <Col>Exercisable Value</Col>
            <Col>Unvested Value</Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 border-bottom text-end">
            <Col>2/4/2021</Col>
            <Col>5,000</Col>
            <Col>$117</Col>
            <Col>1,000</Col>
            <Col>0</Col>
            <Col>$90,660</Col>
            <Col>$0</Col>
          </Row>
          <Row className="text-fs-6 fw-normal lh-xs pt-3 pb-3 border-bottom text-end">
          <Col>Total</Col>
            <Col>5,000</Col>
            <Col></Col>
            <Col>1,000</Col>
            <Col>0</Col>
            <Col>$90,660</Col>
            <Col>$0</Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
export default EquityTab;
